export default __webpack_public_path__ + "static/media/send-icon-white.52ade41e.svg";